import React from "react";
import { AxiosResponse } from "axios";
import { connect } from "react-redux";
import { withRouter, RouteComponentProps } from "react-router";

import { IPageContentShort } from "app/api/types";
import { getShortPageContent } from "app/api/redux/PageContent/actions";
import LayoutUser from "app/components/LayoutUser";

import "./styles.scss";
import { Link } from "react-router-dom";

interface IProps extends RouteComponentProps<{ id: string }> {
  pageList: IPageContentShort[];
  isLoading: boolean;
  getShortPageContent: () => Promise<AxiosResponse>;
}

class PageContentPage extends React.Component<IProps> {
  componentDidMount() {
    this.props.getShortPageContent().catch(err => {
      console.log(err);
    });
  }

  render() {
    return (
      <LayoutUser>
        {this.props.pageList.map(
          page =>
            !page.pageId.match(/\b(\w*service\w*)\b/g) && (
              <Link
                to={`pages/${page.pageId}`}
                key={page.pageId}
                className="page-content__link"
              >
                {page.pageTitle}
              </Link>
            )
        )}
      </LayoutUser>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    pageList: state.pageContents.pageList,
    isLoading: state.pageContents.isLoading
  };
};

export default withRouter(
  connect(mapStateToProps, { getShortPageContent })(PageContentPage)
);
